export const formatSumma = (value) => {
    if (value === undefined || value === null) return "0";

    // Convert to number and fix floating point precision (max 2 decimals)
    // parseFloat removes trailing zeros from toFixed result (e.g. "100.20" -> 100.2)
    const num = parseFloat(Number(value).toFixed(2));

    if (isNaN(num)) return "0";

    const parts = num.toString().split('.');
    const intPart = parts[0];
    const decPart = parts[1];

    // Format integer part with narrow no-break spaces (standard for numbers)
    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, "\u202F");

    return decPart ? `${formattedInt}.${decPart}` : formattedInt;
};
